<div *ngIf="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity animate-fade-in" (click)="closeModal()"></div>

    <!-- Modal Container -->
    <div
        class="relative w-full max-w-4xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-md rounded-3xl shadow-2xl border border-slate-100/50 dark:border-slate-800/50 transform transition-all overflow-hidden flex flex-col max-h-[90vh] animate-fade-in-up">

        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-amber-50 dark:bg-amber-500/10 flex items-center justify-center text-amber-500">
                    <span class="material-icons">edit_note</span>
                </div>
                <div>
                    <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">แก้ไขทะเบียนรถ</h3>
                    <p class="text-xs text-slate-400 dark:text-slate-500">Correct License Plate from Capture Image</p>
                </div>
            </div>
            <button (click)="closeModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">
                <span class="material-icons">close</span>
            </button>
        </div>

        <!-- Body (Grid: Left Image, Right Form) -->
        <div class="p-6 overflow-y-auto custom-scrollbar flex-1 bg-white/30 dark:bg-slate-900/30">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                <!-- Left side: Image Viewer -->
                <div class="flex flex-col gap-2.5">
                    <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">รูปภาพจากกล้อง (LPR Image)</label>
                    <div (click)="isImageZoomed = true"
                        class="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800 flex items-center justify-center group/img cursor-zoom-in">
                        <img [src]="imageUrl"
                            alt="LPR Capture Image"
                            class="w-full h-full object-contain transition-transform duration-300 group-hover/img:scale-105"
                            onerror="this.src='img/notfound.jpg'">
                        <div class="absolute bottom-3 right-3 flex gap-2">
                            <a [href]="imageUrl" target="_blank" (click)="$event.stopPropagation()"
                                class="p-2 bg-slate-900/60 hover:bg-slate-900/80 text-white rounded-xl backdrop-blur-sm transition-all opacity-0 group-hover/img:opacity-100 flex items-center justify-center shadow-md">
                                <span class="material-icons text-sm">open_in_new</span>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Right side: Edit Form -->
                <div class="flex flex-col gap-5 justify-center">
                    <!-- Old License -->
                    <div class="flex flex-col gap-1.5">
                        <label class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">ทะเบียนเดิม (Old License)</label>
                        <div
                            class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-800 border border-slate-200/60 dark:border-slate-700 rounded-xl text-slate-600 dark:text-slate-300 font-mono font-bold select-all flex items-center gap-2">
                            <span class="material-icons-outlined text-slate-400 text-sm">directions_car</span>
                            {{ data.oldLicense || '-' }}
                        </div>
                    </div>

                    <!-- Arrow Down or Right Icon (Hidden on mobile) -->
                    <div class="flex items-center justify-center -my-2 text-slate-350">
                        <span class="material-icons md:hidden">arrow_downward</span>
                        <span class="material-icons hidden md:block">arrow_forward</span>
                    </div>

                    <!-- New License Input -->
                    <div class="flex flex-col gap-1.5">
                        <label class="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider">ทะเบียนใหม่ (New License)
                            <span class="text-rose-500">*</span></label>
                        <div class="relative flex items-center">
                            <span class="absolute left-4 material-icons-outlined text-slate-400 text-lg">drive_file_rename_outline</span>
                            <input type="text" [(ngModel)]="newLicense" placeholder="กรอกเลขทะเบียนที่ถูกต้อง..."
                                class="w-full pl-11 pr-4 py-3 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-200 focus:border-amber-400 text-slate-800 dark:text-slate-100 font-display font-bold placeholder:text-slate-300 dark:placeholder:text-slate-650 transition-all shadow-sm"
                                [disabled]="isLoading">
                        </div>
                        <p class="text-[10px] text-slate-450 dark:text-slate-500">กรุณาตรวจสอบรูปภาพและกรอกเลขทะเบียนที่อ่านได้จริงให้ถูกต้อง</p>
                    </div>
                </div>

            </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 bg-slate-50 dark:bg-slate-800/40 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end gap-3">
            <button (click)="closeModal()"
                class="px-5 py-2.5 rounded-xl text-sm font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-200/50 dark:hover:bg-slate-800 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
                [disabled]="isLoading">
                ยกเลิก
            </button>
            <button (click)="save()"
                class="px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-amber-500 hover:bg-amber-600 shadow-lg shadow-amber-200/50 dark:shadow-none active:scale-95 transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                [disabled]="isLoading || !newLicense">
                <span *ngIf="isLoading"
                    class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                <span *ngIf="!isLoading">บันทึกข้อมูล</span>
            </button>
        </div>

    </div>
</div>

<!-- Image Zoom Overlay -->
<div *ngIf="isImageZoomed" (click)="isImageZoomed = false"
    class="fixed inset-0 z-[100] bg-slate-900/80 backdrop-blur-md flex items-center justify-center p-4 cursor-zoom-out animate-fade-in">
    <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl" (click)="$event.stopPropagation()">
        <img [src]="imageUrl" class="object-contain max-w-full max-h-[90vh]" alt="Enlarged LPR Image" onerror="this.src='img/notfound.jpg'">
        <button (click)="isImageZoomed = false"
            class="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-slate-900/60 hover:bg-slate-900/80 text-white transition-colors">
            <span class="material-icons">close</span>
        </button>
    </div>
</div>
